import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=5fb7cd8c"
import script from "./Buyers.vue?vue&type=script&lang=js"
export * from "./Buyers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports